import React, { useEffect, useState } from "react";
// import logo from "../assets/nestfin/NexfinPng.png";
import logo from "../assets/nestfin/Nestfin_logo.png";
import { components } from "../components";
import { BlockHeading } from "../components/BlockHeading";
import {
  downloadBookingReceipt,
  fetchBookingAmount,
  formatIndianNumber,
  getLeadsBookings,
  getPropertyById,
  propertyTanantAdd,
  updatePaymentStatus,
  viewLeadProfile,
  webCallLead,
} from "../environment";
import useApi from "../customHook/useApi";
import { hooks } from "../hooks";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { CustomLoader, CustomLoaderSmall } from "../components/CustomLoader";
import { callService } from "../customHook/callService";
import downloadIcon from "../assets/nestfin/download.png";
import { APIResponse } from "./CourseDetails";

interface UserFormData {
  fullName: string;
  gender: string;
  country_code: string;
  contact_number: string;
  is_b2b_user: string;
  occupation: string;
  email: string;
  property_id: string;
  property_room_option_id: string;
  room_type_id: string;
  lead_profile_id: string;
  movein_date?: string;
  // amount: number;
}

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: any;
  message?: string;
}

const initialFormData: UserFormData = {
  fullName: "",
  gender: "",
  country_code: "91",
  contact_number: "",
  is_b2b_user: "No",
  occupation: "",
  email: "",
  property_id: "",
  property_room_option_id: "",
  room_type_id: "",
  lead_profile_id: localStorage.getItem("lead_profile_id") || "",
  movein_date: "",
  // amount: parseInt(localStorage.getItem("p") || "0") || 0,
};
export const ListDetails: React.FC = () => {
  const navigate = hooks.useNavigate();
  const [selectedDownloadId, setSelectedDownloadId] = useState<string>("");
  const [formData, setFormData] = useState<UserFormData>(initialFormData);
  const [selectedCourse, setSelectedCourse] = useState<any>({});
  const [isPaymentSubmit, setIsPaymentSubmit] = useState<boolean>(false);
  const [bookingId, setBookingId] = useState<string>("");

  const location = useLocation();

  // console.log(location);

  // API CALL fetch propertydetails
  const {
    data: propertyDetailData,
    loading: propertyDetailLoading,
    callApi: fetchPropertyDetail,
  } = useApi<APIResponse>(getPropertyById, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // Api call here
  const {
    data: myBookingData,
    loading: myBookingDataLoading,
    callApi: fetchBookingData,
  } = useApi<profileResponse>(getLeadsBookings, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    const lead_profile_id = localStorage.getItem("lead_profile_id") ?? "";
    if (lead_profile_id) {
      fetchBookingData({ lead_profile_id });
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   if (myBookingData !== null) {
  //     console.log(myBookingData?.data?.data, "myBookingData222............");
  //   } else {
  //     console.log("Data is Null");
  //   }
  // }, [myBookingData]);

  useEffect(() => {
    // console.log(myBookingData, "myBookingData............");
  }, [myBookingData]);

  //   // --- useApi updatePaymentStatus ---
  const {
    data: paymentResponse,
    loading: paymentLoading,
    callApi: updatePaymentStatusApi, // your API call method
  } = useApi<any>(updatePaymentStatus, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  //   // --- useApi updatePaymentStatus ---
  const {
    data: receiptResponse,
    loading: downlaodLoading,
    callApi: downloadReceiptApi,
  } = useApi<any>(`${downloadBookingReceipt}`, {
    method: "GET",
    autoCall: false,
    isBinary: true,
  });

  // API for fetch booking amount
  const {
    data: fetchAmountData,
    loading: fetchAmountLoading,
    callApi: fetchBookingAmountData,
  } = useApi<any>(fetchBookingAmount, {
    method: "GET",
    autoCall: false,
    isBinary: false,
  });

  const {
    data: submitResponse,
    loading: submitLoading,
    callApi: submitTenant,
  } = useApi<any>(propertyTanantAdd, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // Web Call Api
  const {
    data: WebCallApiData,
    loading: WebCallApiLoading,
    callApi: webCallPost,
  } = useApi(webCallLead, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // API CALL FOR /view-lead-profile
  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // useEffect(() => {
  //   const leadId = localStorage.getItem("lead_profile_id") ?? "";

  //   if (Object.keys(selectedCourse)?.length && leadId) {
  //     fetchPropertyDetail({
  //       leadId: leadId,
  //       propertyId: selectedCourse?.propertyId ?? "",
  //       // leadId: "LEAD-B-2025-05-001",
  //       // propertyId: "PR-B-2025-05-078",
  //     });
  //   }
  // }, [selectedCourse]);
  // console.log(propertyDetailData);

  useEffect(() => {
    if (profileData?.data) {
      const data = profileData.data;
      setFormData((prev) => ({
        ...prev,
        fullName: data.full_name ?? "",
        gender: data.gender ?? "",
        contact_number: data.phone_number ?? "",
        email: data.email ?? "",
      }));
      // console.log("Form prefilled with API data:", data);
    }
  }, [profileData]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  // console.log("profile data", profileData?.data);

  const handleDownloadReceipt = async (id: string) => {
    try {
      // console.log("booking id", bookingId);
      // console.log();
      if (!id) return;
      const response = await downloadReceiptApi(
        undefined,
        `${downloadBookingReceipt}/${id}`,
      );
      binaryToDownloadUrl(response, "receipt.pdf");

      // console.log("Booking receipt data:", response);
    } catch (err) {
      console.error("Error downloading receipt:", err);
    }
  };

  function binaryToDownloadUrl(
    binaryStr: ArrayBuffer,
    fileName: string = "file.txt",
  ) {
    const blob = new Blob([binaryStr], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }

  let payload = {};

  // --- Razorpay Payment Handler ---
  // const payNow = async ({
  //   property_name,
  //   // amount = 1000,
  //   amount = 1,
  //   booking_id,
  // }: {
  //   property_name: string;
  //   amount?: number;
  //   booking_id: string;
  // }) => {
  //   try {
  //     const options = {
  //       description: "Payment for services",
  //       image: { logo },
  //       currency: "INR",
  //       // key: "rzp_live_RIB1uuqajdDnTH",
  //       key: process.env.REACT_APP_RAZOR_PAY_API_KEY,
  //       amount: amount * 100,
  //       name: "Nestfin",
  //       prefill: { property_name },
  //       theme: { color: "#7065F0" },

  //       // Razorpay success handler
  //       handler: async function (response: any) {
  //         // console.log("Payment Success:", response);
  //         toast.success("Payment successful!");

  //         const { razorpay_payment_id } = response;

  //         // --- Call backend using useApi hook ---
  //         await updatePaymentStatusApi({
  //           body: {
  //             booking_id,
  //             payment_status: "success",
  //             transaction_id: razorpay_payment_id,
  //             amount,
  //           },
  //         });
  //       },
  //     };

  //     const rzp = new (window as any).Razorpay(options);

  //     rzp.on("payment.cancel", async () => {
  //       toast.error("Payment cancelled by user");

  //       await updatePaymentStatusApi({
  //         body: {
  //           booking_id,
  //           payment_status: "cancelled",
  //           transaction_id: "",
  //           amount,
  //         },
  //       });
  //       reject(new Error("Payment cancelled"));
  //     });
  //     // Payment failed handler
  //     rzp.on("payment.failed", async function (response: any) {
  //       // console.log("Payment Failed:", response);
  //       toast.error("Payment failed. Please try again.");

  //       const payment_id = response?.error?.metadata?.payment_id || "";

  //       await updatePaymentStatusApi({
  //         body: {
  //           booking_id,
  //           payment_status: "failed",
  //           transaction_id: payment_id,
  //           amount,
  //         },
  //       });
  //     });

  //     rzp.open();
  //   } catch (err: any) {
  //     console.error("Unexpected error:", err);
  //     toast.error("Payment initialization failed");
  //   }
  // };
  const payNow = async (
    course: any,
    {
      property_name,
      // amount = 1000,
      amount = 0,
      booking_id,
    }: {
      property_name: string;
      amount?: number;
      booking_id: string;
    },
  ) => {
    return new Promise<{ razorpay_payment_id: string }>((resolve, reject) => {
      try {
        // console.log("--paynow --", payload);
        // return;
        const options = {
          description: "Payment for services",
          image: { logo },
          currency: "INR",
          // key: "rzp_live_RIB1uuqajdDnTH",
          key: process.env.REACT_APP_RAZOR_PAY_API_KEY,
          amount: amount * 100,
          name: "Nestfin",
          prefill: { property_name },
          theme: { color: "#7065F0" },

          // Razorpay success handler
          handler: async function (response: any) {
            // console.log("Payment Success:", response);
            toast.success("Payment successful!");

            const { razorpay_payment_id } = response;

            // --- Call backend using useApi hook ---
            await updatePaymentStatusApi({
              body: {
                booking_id,
                payment_status: "success",
                transaction_id: razorpay_payment_id,
                amount,
              },
            });
            resolve({ razorpay_payment_id });
          },
        };

        const rzp = new (window as any).Razorpay(options);

        rzp.on("payment.cancel", async (response: any) => {
          console.log("on payment cancel :", response);
          toast.error("Payment cancelled by user");
          console.log("--->> cancelled payment <<<---");
          await updatePaymentStatusApi({
            body: {
              booking_id,
              payment_status: "cancelled",
              transaction_id: "",
              amount,
            },
          });
          // rzp.close();
          // reject(new Error("Payment cancelled"));
        });
        // Payment failed handler
        rzp.on("payment.failed", async function (response: any) {
          console.log("Payment Failed:", response);
          toast.error("Payment failed. Please try again.");

          const payment_id = response?.error?.metadata?.payment_id || "";

          await updatePaymentStatusApi({
            body: {
              booking_id,
              payment_status: "failed",
              transaction_id: payment_id,
              amount,
            },
          });
          reject(response); // reject instead of resolve
        });

        rzp.open();
      } catch (err: any) {
        console.error("Unexpected error:", err);
        // toast.error("Payment initialization failed");
      }
    });
  };

  // console.log("profiledata", profileData);
  // payload = {
  //   amount: booking_amount,
  //   email: profileData?.data.email ?? "",
  //   contact: profileData?.data.phone_number ?? "",
  //   name: profileData?.data.full_name ?? "",
  //   booking_id,
  //   property_name: course?.property_name ?? "",
  //   upi_id: "nestfin@upi",
  //   // upi_ref: paymentResponse?.razorpay_payment_id || "N/A",
  //   latitude: course?.latitude,
  //   longitude: course?.longitude,
  //   house_flat_block_no: course?.house_flat_block_no,
  //   address: course?.address,
  // };
  // console.log("payload", payload);
  // console.log("course", course);

  // const handlePayNow = async ({ course }: { course: any }) => {

  const handlePayNow = async (course: any) => {
    const bookingdata = await fetchBookingAmountData();
    if (!bookingdata?.amount) {
      toast.error("Payment failed. Cannot continue to payment.");
      return;
    }
    const tenantResponse = await submitTenant({ ...formData });

    if (
      !tenantResponse?.success ||
      !tenantResponse?.booking_id ||
      !bookingdata?.amount
    ) {
      toast.error("Booking failed. Cannot continue to payment.");
      return;
    }
    const booking_id = course?.booking_id;
    const booking_amount = bookingdata?.amount;

    try {
      const paymentResponse = await payNow(course, {
        property_name: course?.property_name || "Guest",
        amount: booking_amount,
        // amount: 1000,
        booking_id: course?.booking_id,
      });

      console.log("--paymentResponse--", paymentResponse);
      // console.log("--course--", course);

      payload = {
        amount: booking_amount,
        email: profileData?.data.email ?? "",
        contact: profileData?.data.phone_number ?? "",
        name: profileData?.data.full_name ?? "",
        booking_id,
        property_name: course?.property_name ?? "",
        upi_id: "nestfin@upi",
        upi_ref: paymentResponse?.razorpay_payment_id || "N/A",
        latitude: course?.latitude,
        longitude: course?.longitude,
        house_flat_block_no: course?.house_flat_block_no,
        address: course?.address,
      };
      console.log("payload", payload);

      navigate("/payment-detail", {
        state: {
          amount: booking_amount,
          email: profileData?.data.email ?? "",
          contact: profileData?.data.phone_number ?? "",
          name: profileData?.data.full_name ?? "",
          booking_id,
          property_name: course?.property_name ?? "",
          upi_id: "nestfin@upi",
          upi_ref: paymentResponse?.razorpay_payment_id || "N/A",
          latitude: course?.latitude,
          longitude: course?.longitude,
          house_flat_block_no: course?.house_flat_block_no,
          address: course?.address,
        },
      });
    } catch (paymentErr) {
      console.error("Payment flow error:", paymentErr);
    }
  };
  // === web call api ===
  const handleWebCallLead = async (propertyId: any) => {
    // console.log(propertyId, "Click Button");
    const storedLeadId = localStorage.getItem("lead_profile_id") ?? "";
    const payload = {
      property_id: propertyId ?? "",
      lead_id: storedLeadId,
    };

    console.log("web call api payload:", payload);
    try {
      const response = await webCallPost(payload);
      // console.log("API Response:", response);
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  // Get Direction Lead
  const handleGetDirection = (
    e: React.MouseEvent<HTMLAnchorElement>,
    course: any,
  ) => {
    // Prevent parent click handlers
    e.stopPropagation();

    // Optional: prevent default link navigation until API call starts
    // (if you want to ensure the API logs before the redirect)
    // e.preventDefault();

    console.log("🧭 Get Directions clicked for course:", course);

    if (!course?.booking_id) {
      console.warn("⚠️ Missing booking_id for course:", course);
      return;
    }
    handleWebCallLead(course?.property_id);

    callService("GET_DIRECTION", [
      {
        param: "PROPERTY_ID",
        value: course?.property_id,
      },
    ])
      .then((res) => {
        if (res?.data?.length) {
          console.log("✅ GET_DIRECTION response:", res.data);
          // Optionally update local state if needed
          // setPropertiesDetailsData(res.data[0]);
        } else {
          console.warn("⚠️ No data returned from GET_DIRECTION");
        }
      })
      .catch((err) => {
        console.error("❌ GET_DIRECTION API failed:", err);
      });
  };

  const handlePropertyPayNow = async (course: any) => {
    try {
      const leadId = localStorage.getItem("lead_profile_id") ?? "";
      if (!leadId) return;
      console.log(course);

      setIsPaymentSubmit(true);
      const fetchProperty_response = await fetchPropertyDetail({
        leadId: leadId,
        propertyId: course?.property_id ?? "",
      });
      // console.log(pro)
      if (fetchProperty_response?.success) {
        // console.log("fetched --- ", fetchProperty_response?.data);
        let propertyData = fetchProperty_response?.data[0];
        navigate("/room-booking", {
          state: { room: { ...course }, propertyData: propertyData },
        });
        setIsPaymentSubmit(false);
      }
    } catch (error) {
      console.log("error while pay now", error);
      setIsPaymentSubmit(false);
    }
  };

  // Start Component here
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={false}
        line={false}
        leftlogo={true}
        rightlogo={false}
        filter={false}
        title={" "}
        centerImageSrc={logo}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    // console.log(myBookingData?.data, "myBookingData?.data");

    return (
      <main style={{ paddingBottom: 30 }}>
        <BlockHeading
          title="My Booking"
          containerStyle={{ marginTop: 15, padding: "0 20px" }}
        />
        {myBookingDataLoading ? (
          <CustomLoader />
        ) : myBookingData?.data.length === 0 ? (
          <div style={{ padding: "0 20px" }}>
            <h1
              style={{
                fontSize: "19px",
                color: "#555",
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "500",
                letterSpacing: "0.5px",
              }}
            >
              No Booking Available
            </h1>
          </div>
        ) : (
          <div style={{ paddingTop: 10, paddingBottom: 20 }}>
            {myBookingData?.data.map((course: any, index: any) => {
              const isLast = index === myBookingData?.data - 1;
              const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${course?.latitude},${course?.longitude}`;
              return (
                <div
                  key={course?.id + course?.booking_id}
                  style={{
                    margin: "10px 10px 22px",
                    borderRadius: "12px",
                    border: "1px solid #014d4e38",
                    boxShadow: "0 10px 12px rgba(0, 0, 0, 0.1)",
                  }}
                  // onClick={() =>
                  //   navigate("/course-details", {
                  //     // state: { property_id: course.property_id },
                  //     state: { course, property_id: course.property_id },
                  //   })
                  // }
                  onClick={() => {
                    const localitySlug =
                      course?.locality_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "locality";
                    const citySlug =
                      course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                      "city";
                    const propertySlug =
                      course?.property_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "property";

                    const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}`;

                    console.log(">>> course <<<", course);
                    // ---- change ----
                    navigate(customUrl, {
                      state: { course, property_id: course.property_id },
                    });
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      padding: "10px 13px 0px 10px",
                      cursor: "pointer",
                      userSelect: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: isLast ? 0 : 10,
                    }}
                    onClick={() => console.log("Go to course details")}
                  >
                    {/* Image */}
                    <div
                      style={{
                        minWidth: 90,
                        minHeight: 90,
                        marginRight: 12,
                        position: "relative",
                      }}
                    >
                      <img
                        // src={course?.photos[0]?.photo_path || "#"}
                        // src={course?.photos.length > 0 ? course?.photos[0]?.photo_path : "#"}
                        src={
                          course?.photos && course.photos.length > 0
                            ? course.photos[0].photo_path
                            : "https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg?w=1060"
                        }
                        // src="https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg?w=1060"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: 10,
                          position: "absolute",
                          inset: 0,
                        }}
                      />
                    </div>

                    {/* Text Content */}
                    <div style={{ width: "100%", position: "relative" }}>
                      <div style={{ display: "flex", marginLeft: 10 }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              color: "#014d4e",
                              // fontWeight: 700,
                              // fontSize: 16,
                              marginBottom: "5px",
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              style={{
                                backgroundColor: "var(--secondary-color)",
                                padding: "5px 10px",
                                borderRadius: "8px",
                                color: "white",
                                cursor: "pointer",
                                fontSize: "10px",
                                letterSpacing: "1px",
                              }}
                            >
                              {course?.category?.toUpperCase()}
                            </button>

                            <button
                              style={{
                                backgroundColor: "var(--secondary-color)",
                                padding: "5px 10px",
                                borderRadius: "8px",
                                color: "white",
                                cursor: "pointer",
                                fontSize: "10px",
                                letterSpacing: "1px",
                                marginLeft: "10px",
                              }}
                            >
                              {course?.gender_allowed?.toUpperCase()}
                            </button>
                          </div>
                          <div
                            style={{
                              color: "#014d4e",
                              fontWeight: 700,
                              fontSize: 16,
                            }}
                          >
                            {/* ₹{course?.unit_amount} / month */}₹{" "}
                            {formatIndianNumber(course?.unit_amount)} / month
                          </div>
                          <div
                            style={{
                              fontWeight: 500,
                              fontSize: 16,
                              overflow: "hidden",
                              // whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {course.property_name}
                          </div>
                          {course?.house_flat_block_no}
                          {course?.address}
                          {/* {course?.booking_status !== "Invited" && (
                            <div style={{ fontSize: 13, color: "#555" }}>
                              {course.locality_name} {course.city_name}
                               
                            </div>
                          )} */}
                          {/* {course?.booking_status === "Invited" && (
                            <div
                              style={{
                                fontSize: 12,
                                color: "#555",
                                lineHeight: "18px",
                              }}
                            >
                              {course?.house_flat_block_no} {course?.address}
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Booking Info and Action Section */}
                  <div
                    style={{
                      borderBottom: "1px solid #eee",
                      paddingBottom: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {/* ====== TOP ROW: Booking Date & Status ====== */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px 20px 0",
                        fontSize: 13,
                        color: "#333",
                      }}
                    >
                      {/* Booking Date */}
                      <div>
                        <span style={{ fontWeight: 600 }}>Booking Date: </span>
                        <strong>
                          {new Date(course.created_at).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </strong>
                      </div>

                      {/* Status for Paid or Cancelled */}
                      {course?.booking_status === "Invited" && (
                        <>
                          <span
                            className=""
                            style={{
                              padding: "4px 8px",
                              backgroundColor: "#e0ffe0",
                              color: "#2e7d32",

                              borderRadius: "4px",
                              fontWeight: 600,
                              fontSize: 12,
                            }}
                          >
                            Completed
                          </span>

                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              const id = course?.booking_id;
                              setSelectedDownloadId(id);
                              handleDownloadReceipt(id);
                            }}
                            className="download-receipt-icon"
                            style={{
                              padding: "4px 6px",
                              borderRadius: "5px",
                              // border: "1px solid red",
                            }}
                            disabled={downlaodLoading}
                          >
                            {downlaodLoading &&
                            course?.booking_id == selectedDownloadId ? (
                              <CustomLoaderSmall size="16px" />
                            ) : (
                              <img
                                src={downloadIcon}
                                alt="download icon"
                                className="object-fit-cover "
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  // border: "1px solid brown",
                                }}
                              />
                            )}
                          </button>
                        </>
                      )}

                      {course?.booking_status === "Booked" && (
                        <span
                          style={{
                            padding: "4px 8px",
                            backgroundColor: "#e0ffe0",
                            color: "#2e7d32",
                            borderRadius: "4px",
                            fontWeight: 600,
                            fontSize: 12,
                          }}
                        >
                          Booked
                        </span>
                      )}

                      {course?.booking_status === "Cancelled" && (
                        <span
                          style={{
                            padding: "4px 8px",
                            color: "#c62828",
                            borderRadius: "4px",
                            fontWeight: 600,
                            fontSize: 12,
                          }}
                        >
                          Cancelled
                        </span>
                      )}
                    </div>

                    {/* ====== SECOND ROW (for Not Paid users) ====== */}
                    {course?.booking_status === "Initiated" && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          padding: "10px 20px 15px",
                        }}
                      >
                        {/* Pay Now */}
                        <button
                          disabled={
                            isPaymentSubmit
                            // && course.booking_id == selectedCourse.booking_id
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            padding: "6px 12px",
                            backgroundColor: "#fff",
                            border: `1px solid ${
                              isPaymentSubmit ? "gray" : "#000"
                            }`,
                            color: `${
                              isPaymentSubmit
                                ? // && course.booking_id == selectedCourse.booking_id
                                  "gray"
                                : "#000"
                            }`,
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: 12,
                            transition: "all 0.3s ease",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedCourse(course);
                            // console.log("---course---", course);
                            setIsPaymentSubmit(true);
                            handlePropertyPayNow(course);
                            // handlePayNow(course);
                          }}
                        >
                          {/* {<Loading />} */}
                          Pay Now
                          {isPaymentSubmit &&
                            course.booking_id == selectedCourse.booking_id && (
                              <CustomLoaderSmall size="17px" />
                            )}
                        </button>

                        {/* Get Directions */}
                        <a
                          href={directionsUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "inline-block",
                            backgroundColor: "#fecc00",
                            border: "1px solid #fecc00",
                            color: "#014d4e",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            fontSize: 12,
                            cursor: "pointer",
                          }}
                          // onClick={(e) => e.stopPropagation()}
                          onClick={(e) => {
                            e.stopPropagation();
                            // handleWebCallLead(course?.booking_id);
                            handleGetDirection(e, course);
                          }}
                        >
                          Get Directions
                        </a>
                      </div>
                    )}

                    {(course?.booking_status === "Invited" ||
                      course?.booking_status === "Booked") && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "15px 20px 0px",
                        }}
                      >
                        {/* Call Now */}
                        <button
                          type="button"
                          style={{
                            display: "inline-block",
                            backgroundColor: "#fecc00",
                            // backgroundColor: course?.contact_phone
                            //   ? "#fecc00"
                            //   : "#ccc",
                            // borderColor: course?.contact_phone
                            //   ? "#fecc00"
                            //   : "#ccc",
                            border: "1px solid",
                            borderColor: "#fecc00",
                            color: "#014d4e",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            fontSize: 13,
                            cursor: course?.contact_phone
                              ? "pointer"
                              : "not-allowed",
                            opacity: course?.contact_phone ? 1 : 0.6,
                            // pointerEvents: course?.contact_phone
                            //   ? "auto"
                            //   : "none",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            console.log(
                              "contact_number",
                              course.contact_number,
                            );
                            if (!course?.contact_phone) return {};
                            window.location.href = `tel:${course.contact_phone}`;
                          }}
                        >
                          Call Now
                        </button>

                        {/* Get Directions */}
                        <a
                          href={directionsUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "inline-block",
                            backgroundColor: "#fecc00",
                            border: "1px solid #fecc00",
                            color: "#014d4e",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            fontSize: 13,
                          }}
                          // onClick={(e) => e.stopPropagation()}
                          onClick={(e) => handleGetDirection(e, course)}
                        >
                          Get Directions
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          // <div style={{ paddingTop: 10, paddingBottom: 20 }}>
          //   {myBookingData?.data?.map((course: any, index: any) => {
          //     const isLast = index === myBookingData?.data - 1;
          //     const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${course?.latitude},${course?.longitude}`;
          //     return (
          //       <div
          //         key={course.id}
          //         style={{
          //           margin: "10px 10px 22px",
          //           borderRadius: "12px",
          //           border: "1px solid #014d4e38",
          //           boxShadow: "0 10px 12px rgba(0, 0, 0, 0.1)",
          //         }}
          //         // onClick={() =>
          //         //   navigate("/course-details", {
          //         //     // state: { property_id: course.property_id },
          //         //     state: { course, property_id: course.property_id },
          //         //   })
          //         // }
          //         onClick={() => {
          //           const localitySlug =
          //             course?.locality_name
          //               ?.toLowerCase()
          //               ?.replace(/\s+/g, "-") || "locality";
          //           const citySlug =
          //             course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
          //             "city";
          //           const propertySlug =
          //             course?.property_name
          //               ?.toLowerCase()
          //               ?.replace(/\s+/g, "-") || "property";

          //           const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}`;

          //           navigate(customUrl, {
          //             state: { course, property_id: course.property_id },
          //           });
          //         }}
          //       >
          //         {/* <h1>okkook</h1> */}
          //         <div
          //           style={{
          //             width: "100%",
          //             padding: "10px 13px 0px 10px",
          //             cursor: "pointer",
          //             userSelect: "none",
          //             display: "flex",
          //             alignItems: "center",
          //             justifyContent: "center",
          //             marginBottom: isLast ? 0 : 10,
          //           }}
          //           onClick={() => console.log("Go to course details")}
          //         >
          //           {/* Image */}
          //           <div
          //             style={{
          //               minWidth: 90,
          //               minHeight: 90,
          //               marginRight: 12,
          //               position: "relative",
          //               // border: "1px solid red",
          //               display: "flex",
          //               alignItems: "center",
          //               justifyContent: "center",
          //             }}
          //           >
          //             <img
          //               // src={course?.photos[0]?.photo_path || "#"}
          //               // src={course?.photos.length > 0 ? course?.photos[0]?.photo_path : "#"}
          //               src={
          //                 course?.photos && course.photos.length > 0
          //                   ? course.photos[0].photo_path
          //                   : "https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg?w=1060"
          //               }
          //               // src="https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg?w=1060"
          //               style={{
          //                 width: "100%",
          //                 height: "max-content",
          //                 margin: "auto",
          //                 // border: "1px solid black",
          //                 // height: "100%",
          //                 borderRadius: 10,
          //                 position: "absolute",
          //                 inset: 0,
          //                 objectFit: "cover",
          //               }}
          //             />
          //           </div>

          //           {/* Text Content */}
          //           <div style={{ width: "100%", position: "relative" }}>
          //             <div style={{ display: "flex", marginLeft: 10 }}>
          //               <div
          //                 style={{
          //                   display: "flex",
          //                   flexDirection: "column",
          //                   gap: 3,
          //                   width: "100%",
          //                 }}
          //               >
          //                 <div
          //                   style={{
          //                     color: "#014d4e",
          //                     // fontWeight: 700,
          //                     // fontSize: 16,
          //                     marginBottom: "5px",
          //                     display: "flex",
          //                     justifyContent: "flex-end",
          //                   }}
          //                 >
          //                   <button
          //                     style={{
          //                       backgroundColor: "var(--secondary-color)",
          //                       padding: "5px 10px",
          //                       borderRadius: "8px",
          //                       color: "white",
          //                       cursor: "pointer",
          //                       fontSize: "10px",
          //                       letterSpacing: "1px",
          //                     }}
          //                   >
          //                     {course?.category?.toUpperCase()}
          //                   </button>

          //                   <button
          //                     style={{
          //                       backgroundColor: "var(--secondary-color)",
          //                       padding: "5px 10px",
          //                       borderRadius: "8px",
          //                       color: "white",
          //                       cursor: "pointer",
          //                       fontSize: "10px",
          //                       letterSpacing: "1px",
          //                       marginLeft: "10px",
          //                     }}
          //                   >
          //                     {course?.gender_allowed?.toUpperCase()}
          //                   </button>
          //                 </div>
          //                 <div
          //                   style={{
          //                     color: "#014d4e",
          //                     fontWeight: 700,
          //                     fontSize: 16,
          //                   }}
          //                 >
          //                   {/* ₹{course?.unit_amount} / month */}₹{" "}
          //                   {formatIndianNumber(course?.unit_amount)} / month
          //                 </div>
          //                 <div
          //                   style={{
          //                     fontWeight: 500,
          //                     fontSize: 16,
          //                     overflow: "hidden",
          //                     whiteSpace: "nowrap",
          //                     textOverflow: "ellipsis",
          //                   }}
          //                 >
          //                   {course.property_name}
          //                 </div>
          //                 {course?.house_flat_block_no} {course?.address}
          //                 {/* {course?.booking_status !== "Invited" && (
          //                   <div style={{ fontSize: 13, color: "#555" }}>
          //                     {course.locality_name} {course.city_name}

          //                   </div>
          //                 )} */}
          //                 {/* {course?.booking_status === "Invited" && (
          //                   <div
          //                     style={{
          //                       fontSize: 12,
          //                       color: "#555",
          //                       lineHeight: "18px",
          //                     }}
          //                   >
          //                     {course?.house_flat_block_no} {course?.address}
          //                   </div>
          //                 )} */}
          //               </div>
          //             </div>
          //           </div>
          //         </div>

          //         {/* Booking Info and Action Section */}
          //         <div
          //           style={{
          //             borderBottom: "1px solid #eee",
          //             paddingBottom: "10px",
          //             marginBottom: "10px",
          //           }}
          //         >
          //           {/* ====== TOP ROW: Booking Date & Status ====== */}
          //           <div
          //             style={{
          //               display: "flex",
          //               justifyContent: "space-between",
          //               alignItems: "center",
          //               padding: "10px 20px 0",
          //               fontSize: 13,
          //               color: "#333",
          //             }}
          //           >
          //             {/* Booking Date */}
          //             <div>
          //               <span style={{ fontWeight: 600 }}>Booking Date: </span>
          //               <strong>
          //                 {new Date(course.created_at).toLocaleString("en-IN", {
          //                   day: "2-digit",
          //                   month: "short",
          //                   year: "numeric",
          //                   hour: "2-digit",
          //                   minute: "2-digit",
          //                   hour12: true,
          //                 })}
          //               </strong>
          //             </div>

          //             <div
          //               className=""
          //               style={{
          //                 display: "flex",
          //                 alignItems: "center",
          //                 gap: "7px",
          //               }}
          //             >
          //               <div>
          //                 {/* Status for Paid or Cancelled */}
          //                 {course?.booking_status === "Invited" && (
          //                   <span
          //                     style={{
          //                       padding: "4px 8px",
          //                       backgroundColor: "#e0ffe0",
          //                       color: "#2e7d32",
          //                       borderRadius: "4px",
          //                       fontWeight: 600,
          //                       fontSize: 12,
          //                     }}
          //                   >
          //                     Completed
          //                   </span>
          //                 )}

          //                 {course?.booking_status === "Booked" && (
          //                   <span
          //                     style={{
          //                       padding: "4px 8px",
          //                       backgroundColor: "#e0ffe0",
          //                       color: "#2e7d32",
          //                       borderRadius: "4px",
          //                       fontWeight: 600,
          //                       fontSize: 12,
          //                     }}
          //                   >
          //                     Booked
          //                   </span>
          //                 )}

          //                 {course?.booking_status === "Cancelled" && (
          //                   <span
          //                     style={{
          //                       padding: "4px 8px",
          //                       color: "#c62828",
          //                       borderRadius: "4px",
          //                       fontWeight: 600,
          //                       fontSize: 12,
          //                     }}
          //                   >
          //                     Cancelled
          //                   </span>
          //                 )}
          //               </div>
          //               {/* --- download icon --- */}
          //               {(course?.booking_status === "Invited" ||
          //                 course?.booking_status === "Booked") && (
          //                 <>
          // <button
          //   type="button"
          //   onClick={(e) => {
          //     e.stopPropagation();
          //     const id = course?.booking_id;
          //     setSelectedDownloadId(id);
          //     handleDownloadReceipt(id);
          //   }}
          //   className="download-receipt-icon"
          //   style={{
          //     padding: "4px 6px",
          //     borderRadius: "5px",
          //   }}
          //   disabled={downlaodLoading}
          // >
          // {downlaodLoading &&
          // course?.booking_id == selectedDownloadId ? (
          //   <CustomLoaderSmall size="16px" />
          // ) : (
          // <img
          //   src={downloadIcon}
          //   alt="download icon"
          //   className="object-fit-cover"
          //   style={{
          //     width: "18px",
          //     height: "18px",
          //     // border: "1px solid brown",
          //   }}
          // />
          //                     )}
          //                   </button>
          //                 </>
          //               )}
          //             </div>
          //           </div>

          //           {/* ====== SECOND ROW (for Not Paid users) ====== */}
          //           {course?.booking_status === "Initiated" && (
          //             <div
          //               style={{
          //                 display: "flex",
          //                 justifyContent: "flex-end",
          //                 gap: "10px",
          //                 padding: "10px 20px 15px",
          //               }}
          //             >
          //               {/* Pay Now */}
          //               <button
          //                 style={{
          //                   padding: "6px 12px",
          //                   backgroundColor: "#fff",
          //                   border: "1px solid #000",
          //                   borderRadius: "4px",
          //                   cursor: "pointer",
          //                   fontWeight: 600,
          //                   fontSize: 12,
          //                   transition: "all 0.3s ease",
          //                 }}
          //                 onClick={(e) => {
          //                   e.stopPropagation();
          //                   payNow({
          //                     property_name: course?.property_name || "Guest",
          //                     amount: 1000,
          //                     booking_id: course?.booking_id,
          //                   });
          //                 }}
          //               >
          //                 Pay Now
          //               </button>

          //               {/* Get Directions */}
          //               <a
          //                 href={directionsUrl}
          //                 target="_blank"
          //                 rel="noopener noreferrer"
          //                 style={{
          //                   display: "inline-block",
          //                   backgroundColor: "#fecc00",
          //                   border: "1px solid #fecc00",
          //                   color: "#014d4e",
          //                   padding: "6px 12px",
          //                   borderRadius: "6px",
          //                   textDecoration: "none",
          //                   fontWeight: "bold",
          //                   fontSize: 12,
          //                 }}
          //                 onClick={(e) => e.stopPropagation()}
          //               >
          //                 Get Directions
          //               </a>
          //             </div>
          //           )}

          //           {(course?.booking_status === "Invited" ||
          //             course?.booking_status === "Booked") && (
          //             <div
          //               style={{
          //                 display: "flex",
          //                 justifyContent: "space-between",
          //                 padding: "15px 20px 0px",
          //               }}
          //             >
          //               {/* Call Now */}
          //               <div
          //                 style={{
          //                   display: "inline-block",
          //                   backgroundColor: course?.contact_phone
          //                     ? "#fecc00"
          //                     : "#ccc",
          //                   border: "1px solid",
          //                   borderColor: course?.contact_phone
          //                     ? "#fecc00"
          //                     : "#ccc",
          //                   color: "#014d4e",
          //                   padding: "6px 12px",
          //                   borderRadius: "6px",
          //                   textDecoration: "none",
          //                   fontWeight: "bold",
          //                   fontSize: 13,
          //                   cursor: course?.contact_phone
          //                     ? "pointer"
          //                     : "not-allowed",
          //                   opacity: course?.contact_phone ? 1 : 0.6,
          //                   pointerEvents: course?.contact_phone
          //                     ? "auto"
          //                     : "none",
          //                 }}
          //                 onClick={(e) => {
          //                   if (!course?.contact_phone) return;
          //                   e.stopPropagation();
          //                   window.location.href = `tel:${course.contact_phone}`;
          //                 }}
          //               >
          //                 Call Now
          //               </div>

          //               {/* Get Directions */}
          //               <a
          //                 href={directionsUrl}
          //                 target="_blank"
          //                 rel="noopener noreferrer"
          //                 style={{
          //                   display: "inline-block",
          //                   backgroundColor: "#fecc00",
          //                   border: "1px solid #fecc00",
          //                   color: "#014d4e",
          //                   padding: "6px 12px",
          //                   borderRadius: "6px",
          //                   textDecoration: "none",
          //                   fontWeight: "bold",
          //                   fontSize: 13,
          //                 }}
          //                 // onClick={(e) => e.stopPropagation()}
          //                 onClick={(e) => handleGetDirection(e, course)}
          //               >
          //                 Get Directions
          //               </a>
          //             </div>
          //           )}
          //         </div>
          //       </div>
          //     );
          //   })}
          // </div>
        )}

        {/* {myBookingData?.data.length === 0 ? (
          <div style={{ padding: "0 20px" }}>
            <h1
              style={{
                fontSize: "19px",
                color: "#555",
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "500",
                letterSpacing: "0.5px",
              }}
            >
              No Booking Available
            </h1>
          </div>
        ) : (
          <div style={{ paddingTop: 10, paddingBottom: 20 }}>
            {myBookingData?.data.map((course: any, index: any) => {
              const isLast = index === myBookingData?.data - 1;
              const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${course?.latitude},${course?.longitude}`;

              return (
                <div
                  key={course.id}
                  style={{
                    margin: "10px 10px 22px",
                    borderRadius: "12px",
                    border: "1px solid #014d4e38",
                    boxShadow: "0 10px 12px rgba(0, 0, 0, 0.1)",
                  }}
                  // onClick={() =>
                  //   navigate("/course-details", {
                  //     // state: { property_id: course.property_id },
                  //     state: { course, property_id: course.property_id },
                  //   })
                  // }
                  onClick={() => {
                    const localitySlug =
                      course?.locality_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "locality";
                    const citySlug =
                      course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                      "city";
                    const propertySlug =
                      course?.property_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "property";

                    const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}`;

                    navigate(customUrl, {
                      state: { course, property_id: course.property_id },
                    });
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      padding: "10px 13px 0px 10px",
                      cursor: "pointer",
                      userSelect: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: isLast ? 0 : 10,
                    }}
                    onClick={() => console.log("Go to course details")}
                  >
     
                    <div
                      style={{
                        minWidth: 90,
                        minHeight: 90,
                        marginRight: 12,
                        position: "relative",
                      }}
                    >
                      <img
                        // src={course?.photos[0]?.photo_path || "#"}
                        // src={course?.photos.length > 0 ? course?.photos[0]?.photo_path : "#"}
                        src={
                          course?.photos && course.photos.length > 0
                            ? course.photos[0].photo_path
                            : "https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg?w=1060"
                        }
                        // src="https://img.freepik.com/premium-vector/default-image-icon-vector-missing-picture-page-website-design-mobile-app-no-photo-available_87543-11093.jpg?w=1060"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: 10,
                          position: "absolute",
                          inset: 0,
                        }}
                      />
                    </div>

             
                    <div style={{ width: "100%", position: "relative" }}>
                      <div style={{ display: "flex", marginLeft: 10 }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              color: "#014d4e",
                              fontWeight: 700,
                              fontSize: 16,
                            }}
                          >
                            ₹{course?.unit_amount} / month
                          </div>

                          <div
                            style={{
                              fontWeight: 500,
                              fontSize: 16,
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {course.property_name}
                          </div>

                          {course?.booking_status !== "Invited" && (
                            <div style={{ fontSize: 13, color: "#555" }}>
                              {course.locality_name} {course.city_name}
                            </div>
                          )}

                          {course?.booking_status === "Invited" && (
                            <div
                              style={{
                                fontSize: 12,
                                color: "#555",
                                lineHeight: "18px",
                              }}
                            >
                              {course?.house_flat_block_no} {course?.address}
                                                     </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px 20px 15px",
                      fontSize: 13,
                      color: "#333",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: 600 }}>Booking Date: </span>
                      <strong>
                        {new Date(course.created_at).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        fontSize: 13,
                      }}
                    >
                      {course?.booking_status === "Initiated" && (
                        <button
                          style={{
                            padding: "4px 8px",
                            backgroundColor: "#fff",
                            border: "1px solid #000",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: 12,
                            transition: "all 0.3s ease",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();

                            // Call Razorpay payment
                            payNow({
                              property_name: course?.property_name || "Guest",
                              // amount: course?.unit_amount || 1,
                              amount: 2000,
                              booking_id: course?.booking_id,
                            });
                          }}
                        >
                          Pay Now
                        </button>
                      )}

                      {course?.booking_status === "Invited" && (
                        <span
                          style={{
                            padding: "4px 8px",
                            backgroundColor: "#e0ffe0",
                            color: "#2e7d32",
                            // border: "1px solid #2e7d32",
                            borderRadius: "4px",
                            fontWeight: 600,
                            fontSize: 12,
                          }}
                        >
                          Completed
                        </span>
                      )}

                      {course?.booking_status === "Cancelled" && (
                        <span
                          style={{
                            padding: "4px 8px",
                            // backgroundColor: "#ffe0e0",
                            color: "#c62828",
                            // border: "1px solid #c62828",
                            borderRadius: "4px",
                            fontWeight: 600,
                            fontSize: 12,
                          }}
                        >
                          Cancelled
                        </span>
                      )}
                    </div>
                  </div>
                  {course?.booking_status === "Invited" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "0 20px 15px",
                      }}
                    >
                      <div
                        style={{
                          display: "inline-block",
                          backgroundColor: course?.contact_phone
                            ? "#fecc00"
                            : "#ccc", // gray if disabled
                          border: "1px solid",
                          borderColor: course?.contact_phone
                            ? "#fecc00"
                            : "#ccc",
                          color: "#014d4e",
                          padding: "5px 10px",
                          borderRadius: "6px",
                          textDecoration: "none",
                          fontWeight: "bold",
                          fontSize: 13,
                          cursor: course?.contact_phone
                            ? "pointer"
                            : "not-allowed", // show disabled cursor
                          opacity: course?.contact_phone ? 1 : 0.6, // slightly faded when disabled
                          pointerEvents: course?.contact_phone
                            ? "auto"
                            : "none", // prevent clicks if disabled
                        }}
                        onClick={(e) => {
                          if (!course?.contact_phone) return; // stop if no number
                          e.stopPropagation();
                          window.location.href = `tel:${course.contact_phone}`;
                        }}
                      >
                        Call Now
                      </div>

                      <a
                        href={directionsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "inline-block",
                          backgroundColor: "#fecc00",
                          border: "1px solid #fecc00",
                          color: "#014d4e  ",
                          padding: "5px 10px",
                          borderRadius: "6px",
                          textDecoration: "none",
                          fontWeight: "bold",
                          fontSize: 13,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        Get Directions
                      </a>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )} */}
      </main>
    );
  };

  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};
